import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError, fmtDateTime } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/audit", { params: { q } });
      setLogs(data);
    } catch (e) { toast.error(apiError(e)); }
  }, [q]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5" data-testid="audit-page">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Audit Log</h1>
        <p className="mt-1 text-sm text-slate-600">{logs.length} entries · who did what, and when.</p>
      </div>

      <div className="relative max-w-md">
        <Search size={15} className="absolute left-3 top-3.5 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search user, action, entity…"
          data-testid="audit-search-input" className="h-11 border-slate-300 pl-9" />
      </div>

      <div className="overflow-x-auto border border-slate-200">
        <table className="w-full min-w-[760px] text-sm" data-testid="audit-table">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-600">
            <tr className="border-b border-slate-200">
              <th className="px-3 py-2">When</th><th className="px-3 py-2">User</th><th className="px-3 py-2">Role</th>
              <th className="px-3 py-2">Action</th><th className="px-3 py-2">Entity</th><th className="px-3 py-2">Detail</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-slate-100 row-hover hover:bg-slate-50" data-testid={`audit-row-${l.id}`}>
                <td className="px-3 py-2 num whitespace-nowrap text-slate-600">{fmtDateTime(l.at)}</td>
                <td className="px-3 py-2 font-medium text-slate-800">{l.user_name}</td>
                <td className="px-3 py-2 text-xs uppercase tracking-wide text-slate-500">{l.user_role}</td>
                <td className="px-3 py-2">
                  <span className="border border-[#134e4a]/30 bg-[#134e4a]/5 px-1.5 py-0.5 text-xs font-semibold text-[#134e4a]">{l.action}</span>
                </td>
                <td className="px-3 py-2 text-slate-700">{l.entity}</td>
                <td className="px-3 py-2 text-slate-700">{l.detail}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={6} className="px-3 py-10 text-center text-sm text-slate-500">No audit entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
